import styled from '@emotion/styled';

export const SearchButtonWrapper = styled.div`
	position: absolute;
	right: 0;
	top: 0;
	pointer-events: all;
`;
